module.exports = __webpack_public_path__ + "img/cooperative0_logo27.a2f0fcbf.jpg";